import script from "./fishki.vue?vue&type=script&setup=true&lang=js"
export * from "./fishki.vue?vue&type=script&setup=true&lang=js"

import "./fishki.vue?vue&type=style&index=0&id=0a57c048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a57c048"]])

export default __exports__